// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import './utils/cookies'
import Element from 'element-ui'
import router from './router'
import store from '../store'
import 'element-ui/lib/theme-chalk/index.css'
import VueQuillEditor from 'vue-quill-editor' // 引入富文本编译器
import VueCropper from 'vue-cropper'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'

import * as filters from './filters' // global filters
Vue.use(VueQuillEditor)
Vue.config.productionTip = false
Vue.use(Element)
Vue.use(VueCropper)
Vue.prototype.$isNotEmpty = (item) => {
  return (item != null && item !== undefined && item !== '')
}

Vue.prototype.$isEmpty = (item) => {
  return (item == null || item === undefined || item === '')
}

console.log(router.options.routes)
// register global utility filters
Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
})
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js